import React from "react";
import {
    Row,
    Col,
    Modal,
    Form,
    Input,
    Button,
    Spin,
    message,
    Steps,
} from "antd";
import { formItemLayout, tailFormItemLayout } from "$ACTIONS/constantsData";
import { dateFormat, formatSeconds, numberConversion } from "$ACTIONS/util";
import { Cookie } from "$ACTIONS/helper";
import { get, post, patch } from "$ACTIONS/TlcRequest";
import { ApiPort, APISET, APISETS } from "$ACTIONS/TLCAPI";
import { otpNumReg } from "$ACTIONS/reg";
import PhoneEdit from "@/Verification/PhoneEdit";
import Router from "next/router";
import ExceedVerify from "@/OTP/ExceedVerify";
import classNames from "classnames";
import { connect } from "react-redux";
const { Item } = Form;
const { Step } = Steps;
class PhoneVerify extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            remainingTime: -1,
            exceedVisible: false, // otp 超過驗證次數判斷
            buttonStatus: false,
            phone: "",
            sendBtnDisable: false,
            memberInfo: JSON.parse(localStorage.getItem("memberInfo")),
        };

        this.PhoneVerify = this.PhoneVerify.bind(this); // 发送验证码
        this.checkUrlVerifyCode = this.checkUrlVerifyCode.bind(this); // 验证手机号
        this.startCountDown = this.startCountDown.bind(this); // 倒计时

        this.phoneNumber = ""; // 仅允许单词更改手机号，为了保证更改后能够实时获取到数据，采用本地属性记录方式
        this.timeTimer = null; // 倒计时Timer
    }
    componentDidMount() {
        if (!this.props.phone) {
            this.setState({ isLoading: true });
            get(ApiPort.GETMemberlistAPI)
                .then((res) => {
                    if (res && res.isSuccess) {
                        res.result.memberInfo.contacts.forEach((val) => {
                            val.contactType === "Phone" &&
                                this.setState({ phone: val.contact });
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    return null;
                })
                .finally(() => {
                    this.setState({ isLoading: false });
                });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.visible !== this.props.visible) {
            this.props.otpParam && this.getPhoneOTPAttempts();
            Cookie.Get("phoneTime") !== "" && this.props.visible
                ? this.startCountDown()
                : clearInterval(this.timeTimer);
        }
    }
    componentWillUnmount() {
        clearInterval(this.timeTimer);
    }
    /**
     * 获取手机验证次数
     * （添加泰达币提现钱包不用获取这支API，他们有自己的API（CheckIsAbleSmsOTP））
     * 泰达币添加钱包验证有两个地方，一个泰达币提现那里有验证，usercenter里的提现账户那里验证
     */
    getPhoneOTPAttempts = () => {
        const { otpParam, kindOfVerifications } = this.props;
        console.log(
            "otpParam,kindOfVerifications:",
            otpParam,
            kindOfVerifications
        );
        if (otpParam == "memberProfile-otp" || otpParam == "login-otp") {
            let type = "";
            if (otpParam == "memberProfile-otp") {
                //个人资料验证
                type = "ContactVerification";
            } else if (
                otpParam == "login-otp" &&
                kindOfVerifications == "OTP"
            ) {
                //loginotp
                type = "OTP";
            } else if (
                otpParam == "login-otp" &&
                kindOfVerifications == "revalidate"
            ) {
                //loginotp + 重置密码
                type = "Revalidate";
            }
            this.setState({ isLoading: true });
            get(
                ApiPort.GetOTPAttempts +
                    `&channelType=${"SMS"}&serviceAction=${type}&`
            )
                .then((res) => {
                    if (res && res.result) {
                        this.setState({ isLoading: false });
                        if (res.result.attempt < 1) {
                            if (otpParam == "memberProfile-otp") {
                                this.props.closeModal();
                            } else if (otpParam == "login-otp") {
                                this.props.changeVerify("Phone", false, false);
                            }
                            this.setState({
                                exceedVisible: true,
                            });
                        } else if (res.result.attempt) {
                            this.props.setAttemptRemaining(res.result.attempt);
                        }
                    }
                })
                .catch((error) => {
                    console.log("获取手机验证次数 error:", error);
                    this.setState({ isLoading: false });
                });
        }
    };
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.checkUrlVerifyCode(values.verifyCode);
            }
        });

        if (this.props.otpParam === "login-otp") {
            Pushgtagdata("Verification", "Submit", "Verify_Phone_LoginOTP");
        } else if (this.props.otpParam === "cry-otp") {
            Pushgtagdata("Verification", "Submit", "Verify_Phone_cry-OTP");
        } else if (this.props.otpParam === "memberProfile-otp") {
            Pushgtagdata("Verification", "Submit", "Verify_Phone_ProfilePage");
        } else {
            Pushgtagdata("Verification", "Submit", "Submit_phoneverification");
        }
    };
    startCountDown() {
        this.setState({ remainingTime: 300 });
        clearInterval(this.timeTimer);
        if (Cookie.Get("phoneTime")) {
            const phoneTime = Cookie.Get("phoneTime")
                .replace("-", "/")
                .replace("-", "/");
            let lastSeconds = parseInt(
                300 -
                    (new Date().getTime() - new Date(phoneTime).getTime()) /
                        1000
            );
            this.setState({ buttonStatus: true });
            this.timeTimer = setInterval(() => {
                if (lastSeconds <= 0) {
                    this.clearTime();
                    this.props.judgeOTPVerification &&
                        this.props.judgeOTPVerification(
                            this.props.usdtWithdrawType
                        ); // cryOtp
                }
                this.setState({ remainingTime: lastSeconds-- }); // 將button status寫在倒計時，refresh時仍可以正常為true
            }, 1000);
        }
    }

    clearTime(result) {
        Cookie.Delete("phoneTime");
        clearInterval(this.timeTimer);
        // this.setState({ buttonStatus: false });  //為確保五分鐘後仍能提交驗證碼，故comment掉
        if (this.props.otpParam && result) {
            this.setState({ remainingTime: "" });
            this.props.form.setFieldsValue({ verifyCode: "" }); // 輸入匡改為空值
            return;
        }
    }

    PhoneVerify(isResend) {
        console.log(
            "isResend",
            isResend,
            "--->",
            !isResend ? "SendCode_Phone" : "ResendCode_Phone"
        );
        if (!this.state.sendBtnDisable) {
            let URL =
                ApiPort.POSTPhoneVerifyAPI + "?isFirstRequest=false" + APISETS;
            let PhoneData;
            const { UserName, Currency, MemberCode } = this.state.memberInfo;
            if (
                this.props.otpParam === "login-otp" &&
                this.props.kindOfVerifications === "revalidate"
            ) {
                //OTP Reset Password
                PhoneData = {
                    msIsdn:
                        this.phoneNumber ||
                        this.props.phone ||
                        this.state.phone, // 优先更新后的手机号，然后父级传入，接着本组件获取到的
                    isRegistration: false, // 是不是注册
                    isOneTimeService: false, // 只有注册时候才为true
                    userName: UserName,
                    memberCode: MemberCode,
                    currencyCode: "CNY",
                    siteId: 37,
                    isMandatoryStep: false,
                    serviceAction: "Revalidate",
                };
                URL = ApiPort.POSTPhoneVerifyAPI + APISET;
            } else {
                console.log("memberInfo", this.state.memberInfo);
                PhoneData = {
                    msisdn: this.state.memberInfo.isVerifiedPhone[0],
                    // msIsdn: this.phoneNumber || this.props.phone || this.state.phone,
                    isRegistration: false, // 是不是注册
                    isOneTimeService: false, // 只有注册时候才为true
                    userName: UserName,
                    currencyCode: Currency,
                    siteId: 37,
                };

                if (
                    this.props.otpParam === "login-otp" &&
                    this.props.kindOfVerifications === "OTP"
                ) {
                    // login otp用參數
                    PhoneData.memberCode = MemberCode;
                    PhoneData.serviceAction = "OTP";
                    PhoneData.isMandatoryStep = true;
                    URL = ApiPort.POSTPhoneVerifyAPI + APISET;
                }
                if (this.props.otpParam === "cry-otp") {
                    // cry otp
                    const phone =
                        this.phoneNumber ||
                        (this.props.phone
                            ? this.props.phone.replace("-", "")
                            : this.state.phone.replace("-", ""));
                    URL =
                        ApiPort.PostSendSmsOTP +
                        "?phoneNumber=" +
                        phone +
                        APISETS;
                    PhoneData = phone;
                }
                if (this.props.otpParam === "memberProfile-otp") {
                    //(usercenter page)用户中心页面验证手机号
                    (PhoneData.memberCode = MemberCode),
                        (PhoneData.isMandatoryStep = true),
                        (PhoneData.serviceAction = "ContactVerification"),
                        (URL = ApiPort.POSTPhoneVerifyAPI + APISET);
                }
            }
            this.setState({ isLoading: true });
            post(URL, PhoneData)
                .then((res) => {
                    console.log("返回的数据", res);
                    this.setState({ isLoading: false });
                    let { isSuccess, result = {}, errors = [] } = res || {};
                    const [{ errorCode, description: description = "" } = {}] =
                        errors;
                    if (isSuccess == true) {
                        Cookie.Create("phoneTime", dateFormat(), 5);
                        message.success("发送成功");
                        this.startCountDown();
                    } else {
                        if (this.props.otpParam == "login-otp") {
                            // logintop & 重置密码 超过请求次数
                            if (
                                errorCode == "REVA0001" ||
                                errorCode == "VAL18015"
                            ) {
                                this.props.changeVerify("Phone", false, false);
                                this.setState({ exceedVisible: true });
                                return;
                            } else {
                                message.error(
                                    description ||
                                        "发送失败，请稍后在尝试或联系客服!"
                                );
                            }
                        } else if (this.props.otpParam == "memberProfile-otp") {
                            // 个人资料页面超过请求次数
                            if (
                                errorCode == "REVA0001" ||
                                errorCode == "VAL18015"
                            ) {
                                this.props.closeModal();
                                this.setState({ exceedVisible: true });
                            } else {
                                message.error(
                                    description ||
                                        "发送失败，请稍后在尝试或联系客服!"
                                );
                            }
                        } else {
                            message.error(
                                description ||
                                    "发送失败，请稍后在尝试或联系客服!"
                            );
                        }
                        this.props.otpParam === "cry-otp" &&
                        !result.attempts &&
                        description.includes("超过尝试次数")
                            ? this.props.changeVerify(false, false, true)
                            : message.error(description);
                    }
                })
                .catch((error) => {
                    console.log("POSTPhoneVerifyAPI" + error);
                });

            if (this.props.otpParam === "login-otp") {
                Pushgtagdata(
                    "Verification",
                    !isResend ? "Click" : "Request",
                    !isResend ? "SendCode_Phone" : "ResendCode_Phone"
                );
            } else if (this.props.otpParam === "cry-otp") {
                Pushgtagdata(
                    "Verification",
                    "Click",
                    !isResend ? "Sendcode_TTH_Crypto" : "Resendcode_TTH_Crypto"
                );
            } else if (this.props.otpParam === "memberProfile-otp") {
                Pushgtagdata(
                    "Verification",
                    "Click",
                    !isResend
                        ? "SendCode_Phone_ProfilePage"
                        : "ResendCode_Phone_ProfilePage"
                );
            } else {
                Pushgtagdata(
                    "Verification",
                    "Click",
                    !isResend
                        ? "Sendcode_phoneverification"
                        : "Resendcode_phoneverification"
                );
            }
        }
    }
    checkUrlVerifyCode(code) {
        if (!otpNumReg.test(code))
            return global.showResultModal("格式错误", false);
        let URL = ApiPort.POSTPhoneVerifyTAC;
        let PhoneData = {
            verificationCode: code,
            isregistration: false,
            msIsdn: this.state.memberInfo.isVerifiedPhone[0],
            // msIsdn: this.phoneNumber || this.props.phone || this.state.phone,
            userName: this.state.memberInfo.userName,
            siteId: 37,
        };
        if (
            this.props.otpParam === "login-otp" &&
            this.props.kindOfVerifications === "revalidate"
        ) {
            PhoneData.memberCode = this.state.memberInfo.memberCode;
            PhoneData.isMandatorySetp = false;
            PhoneData.serviceAction = "Revalidate";
        } else {
            PhoneData.currencyCode = this.state.memberInfo.currency;
            PhoneData.isMandatorySetp = true;
            PhoneData.serviceAction = "RegistrationBonus";

            if (
                this.props.otpParam === "login-otp" &&
                this.props.kindOfVerifications === "OTP"
            ) {
                // otp 請求用參數
                PhoneData.memberCode = this.state.memberInfo.memberCode;
                PhoneData.serviceAction = "OTP";
            }

            if (this.props.otpParam === "cry-otp") {
                // cry otp 請求url and data
                URL = ApiPort.PostVerifySmsOTP + "?" + APISETS;
                PhoneData.verificationCode = code;
                PhoneData.serviceAction = "CryptoWallet";
            }
            if (this.props.otpParam === "memberProfile-otp") {
                //(usercenter page)用户中心页面验证手机号
                PhoneData.serviceAction = "ContactVerification";
            }
        }
        this.setState({ isLoading: true });
        patch(URL, PhoneData).then((res) => {
            this.setState({ isLoading: false });
            console.log(
                "otpParam,kindOfVerifications",
                this.props.otpParam,
                this.props.kindOfVerifications
            );
            let { isSuccess, result = {}, errors = [] } = res || {};
            const [{ errorCode, message: errorMessage = "" } = {}] = errors;

            if (
                this.props.otpParam === "login-otp" &&
                this.props.kindOfVerifications === "OTP"
            ) {
                //login otp 驗證
                if (isSuccess && result.isVerified) {
                    global.showResultModal(result.message || "验证成功", true);
                    localStorage.setItem("login-otp", true); // 驗證成功

                    if (res.result.queleaReferreeStatus) {
                        this.props.GetThroughoutVerification();
                    }
                    this.clearTime(isSuccess);
                    setTimeout(() => {
                        this.props.changeVerify("Phone", false, false); // 關閉彈窗
                        Router.push("/cn/");
                    }, 3000);
                    return;
                } else {
                    if (res.errors && res.errors.length > 0) {
                        this.props.form.setFields({
                            verifyCode: {
                                value: "",
                                errors: [new Error(res.errors[0].description)],
                            },
                        });
                        return;
                    }
                    if (result.remainingAttempt) {
                        //global.showResultModal(errorMessage || '验证码错误', false);

                        this.props.form.setFields({
                            verifyCode: {
                                value: "",
                                errors: [new Error(result.message)],
                            },
                        });
                        this.props.setAttemptRemaining(result.remainingAttempt);
                        return;
                    } else {
                        // 超過驗證次數
                        this.props.changeVerify("Phone", false, false); // 關閉彈窗
                        this.setState({ exceedVisible: true });
                        return;
                    }
                }
            } else if (this.props.otpParam === "cry-otp") {
                // cry otp 驗證
                if (isSuccess && result) {
                    const verificationCode =
                        this.props.form.getFieldValue("verifyCode");
                    this.props.getVerificationCode(verificationCode);

                    global.showColorResultModal("验证成功", true);
                    this.clearTime(isSuccess);

                    if (res.result.queleaReferreeStatus) {
                        this.props.GetThroughoutVerification();
                    }
                    setTimeout(() => {
                        this.props.changeVerify(false, true, false);
                    }, 3000);
                } else if (!isSuccess) {
                    if (result.attempts) {
                        this.props.form.setFields({
                            verifyCode: {
                                value: "",
                                errors: [new Error(result.message)],
                            },
                        });
                        this.props.setAttemptRemaining(result.attempts);
                        return;
                    } else {
                        if (res.errors) {
                            this.props.form.setFields({
                                verifyCode: {
                                    value: "",
                                    errors: [
                                        new Error(res.errors[0].description),
                                    ],
                                },
                            });
                        }
                        // 確認驗證次數，超過則彈窗超過次數
                        return (
                            this.props.judgeOTPVerification &&
                            this.props.judgeOTPVerification(
                                this.props.usdtWithdrawType
                            )
                        );

                        // this.props.setAttemptRemaining(
                        //     this.props.attemptRemaining - 1
                        // );
                        // return;
                    }
                    // if (!result.attempts) {
                    //     // 超過驗證次數
                    //     return (
                    //         this.props.judgeOTPVerification &&
                    //         this.props.judgeOTPVerification(
                    //             this.props.usdtWithdrawType
                    //         )
                    //     ); // cryOtp
                    // }
                }
            } else if (
                this.props.otpParam === "login-otp" &&
                this.props.kindOfVerifications === "revalidate"
            ) {
                if (isSuccess && result.isVerified) {
                    global.showResultModal("验证成功", true);
                    this.clearTime(isSuccess);

                    if (res.result.queleaReferreeStatus) {
                        this.props.GetThroughoutVerification();
                    }
                    setTimeout(() => {
                        this.props.changeVerify("Phone", false, false); // 關閉彈窗
                        this.props.setReadStep(4); //打开修改密码弹窗
                    }, 3000);
                    return;
                } else {
                    if (result.remainingAttempt) {
                        this.props.form.setFields({
                            verifyCode: {
                                value: "",
                                errors: [new Error(result.message)],
                            },
                        });
                        this.props.setAttemptRemaining(result.remainingAttempt);
                        return;
                    }
                    if (errorCode === "REVA0001" || errorCode == "VAL18015") {
                        // 超過驗證次數
                        this.props.changeVerify("Phone", false, false); // 關閉彈窗
                        this.setState({ exceedVisible: true });
                        return;
                    } else {
                        global.showResultModal(
                            result.exception.message || "短信服务异常",
                            false
                        );
                        this.props.setAttemptRemaining(result.remainingAttempt);
                    }
                }
            } else if (this.props.otpParam === "memberProfile-otp") {
                if (isSuccess && result.isVerified) {
                    global.showResultModalWithColor("验证成功", true, {
                        left: "5%",
                    });
                    // global.showResultModal('验证成功', true);
                    this.clearTime(isSuccess);
                    this.props.correctMemberInfo();
                    setTimeout(() => {
                        this.props.closeModal(); // 關閉彈窗
                    }, 3000);

                    if (res.result.queleaReferreeStatus) {
                        this.props.GetThroughoutVerification();
                    }
                } else {
                    if (result.remainingAttempt) {
                        this.props.form.setFields({
                            verifyCode: {
                                value: "",
                                errors: [new Error(result.message)],
                            },
                        });
                        this.props.setAttemptRemaining(result.remainingAttempt);
                        return;
                    }
                    if (!result.remainingAttempt) {
                        // 超過驗證次數
                        this.props.closeModal(); // 關閉彈窗
                        this.setState({ exceedVisible: true });
                        return;
                    } else {
                        global.showResultModal(
                            errorMessage || "短信服务异常",
                            false
                        );
                        this.props.setAttemptRemaining(result.attemptRemaining);
                    }
                }
            } else {
                // 非otp 驗證
                if (!result.exception) {
                    message.success(result.message || "验证成功");
                    !this.props.otpParam && this.props.correctMemberInfo();
                    !this.props.otpParam && this.props.closeModal();
                } else {
                    message.error(errorMessage);
                }
            }
        });
    }

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { exceedVisible, remainingTime, buttonStatus, memberInfo } =
            this.state;
        const verificationCode = getFieldValue("verifyCode");
        const phone = this.props.phone
            ? this.props.phone.replace("86-", "")
            : this.state.phone.replace("86-", "");
        // const phoneFormat = phone && phone.substr(0, 3) + '*'.repeat(4) + phone.substr(7, 4)
        // console.log('打印标识', remainingTime === '');
        // console.log('打印标识1221', remainingTime);

        console.log("verifycationCode: ", verificationCode);

        console.log("local memberInfo", memberInfo);
        return (
            <React.Fragment>
                <Modal
                    style={this.props.style}
                    className="general-modal"
                    title={
                        this.props.isNext
                            ? "2/2 手机验证"
                            : this.props.otpParam
                            ? this.props.modalTitle
                            : "手机验证"
                    }
                    visible={this.props.visible}
                    width={400}
                    footer={null}
                    centered={true}
                    closable={true}
                    maskClosable={
                        this.props.otpParam == "login-otp" ? false : true
                    }
                    onCancel={() => {
                        if (this.props.otpParam == "login-otp") {
                            this.props.changeVerify("Phone", true, false);
                        } else {
                            this.props.closeModal();
                        }
                    }}
                    zIndex={1500}
                >
                    <Spin
                        spinning={this.state.isLoading}
                        tip="加载中，请稍候..."
                        style={{ backgroundColor: "initial" }}
                    >
                        {this.props.kindOfVerifications == "revalidate" && (
                            <div className="StepsBox">
                                <Steps current={0} size="small">
                                    <Step />
                                    <Step />
                                </Steps>
                            </div>
                        )}

                        <Form
                            className="verification-form-wrap otpVerification"
                            {...formItemLayout}
                            onSubmit={this.handleSubmit}
                        >
                            <h3 className="Otptxt">
                                {this.props.kindOfVerifications == "OTP"
                                    ? "手机接收验证码"
                                    : "验证码验证"}
                            </h3>
                            {this.props.otpParam ? (
                                this.props.Description
                            ) : (
                                <div>
                                    请输入您的手机号，按下【发送验证码】，并输入所收到的验证码进行验证。
                                </div>
                            )}
                            <div className="line-distance" />
                            {!this.props.isEditPhone ? (
                                <Item label="手机号码">
                                    <Row gutter={14}>
                                        <Col span={7}>
                                            <Input
                                                size="large"
                                                className="tlc-input-disabled"
                                                disabled={true}
                                                value="+86"
                                            />
                                        </Col>
                                        <Col span={17}>
                                            <Input
                                                size="large"
                                                className="tlc-input-disabled"
                                                disabled={true}
                                                value={phone.replace(
                                                    /\d(?=\d{4})/g,
                                                    "*"
                                                )}
                                            />
                                        </Col>
                                    </Row>
                                </Item>
                            ) : (
                                <PhoneEdit
                                    disableEdit={buttonStatus}
                                    memberCode={memberInfo.memberCode}
                                    phoneNumber={phone}
                                    isDeposited={memberInfo.isDeposited}
                                    dialogVisible={this.props.visible}
                                    setRemainingTime={(v) => {
                                        this.setState({ remainingTime: v });
                                    }}
                                    updatePhoneNumber={(v) => {
                                        this.phoneNumber = v;
                                    }}
                                    setSendBtnDisable={(v) => {
                                        this.setState({ sendBtnDisable: v });
                                    }}
                                    setLoading={(v) => {
                                        this.setState({ isLoading: v });
                                    }}
                                />
                            )}

                            {
                                this.props.otpParam &&
                                    this.props.callCS /* 聯絡客服 */
                            }

                            <Item label="验证码">
                                {getFieldDecorator("verifyCode", {
                                    rules: [
                                        {
                                            required: true,
                                            message: "请输入验证码！",
                                        },
                                    ],
                                    getValueFromEvent: (event) => {
                                        return event.target.value.replace(
                                            /\D/g,
                                            ""
                                        );
                                    },
                                })(
                                    <Input
                                        maxLength={6}
                                        addonAfter={
                                            remainingTime < 0 ? (
                                                <div
                                                    onClick={() => {
                                                        this.PhoneVerify();
                                                    }}
                                                >
                                                    发送
                                                </div>
                                            ) : remainingTime > 0 ? (
                                                <div style={{ color: "#FFF" }}>
                                                    重发{" "}
                                                    {formatSeconds(
                                                        remainingTime
                                                    )}
                                                </div>
                                            ) : (
                                                !remainingTime && (
                                                    <div
                                                        onClick={() => {
                                                            this.PhoneVerify(
                                                                true
                                                            );
                                                        }}
                                                    >
                                                        重新发送
                                                    </div>
                                                )
                                            )
                                        }
                                        size="large"
                                        autoComplete="off"
                                        className={
                                            remainingTime > 0 ||
                                            this.state.sendBtnDisable
                                                ? "disabled-time"
                                                : "abled-time"
                                        }
                                        placeholder="输入验证码"
                                    />
                                )}
                            </Item>

                            <p className="bottom-sign">
                                {this.props.usdtWithdrawType == "USDT-ERC20" ||
                                this.props.otpParam === "memberProfile-otp"
                                    ? "注意：如果5分钟后仍未收到验证码，请点击 “重发验证码” 以获取新的验证码。"
                                    : "如果您在 5 分钟内没有收到验证码，请点击 “重发验证码” 以获取新的验证码。"}
                            </p>
                            <div className="line-distance" />

                            {this.props.otpParam == "login-otp" ? (
                                <Item {...tailFormItemLayout}>
                                    <div className="btn-wrap otp-btn-wrap verificationSubmitBtn">
                                        <Button
                                            size="large"
                                            className="changeVerify"
                                            onClick={() => {
                                                this.props.changeVerify(
                                                    "Phone",
                                                    true,
                                                    false
                                                );
                                                Pushgtagdata(
                                                    "Change_phone_loginOTP"
                                                );
                                            }}
                                        >
                                            更换验证方式
                                        </Button>
                                        <Button
                                            // style={{background: '#35c95b', color: '#fff'}}
                                            size="large"
                                            type="primary"
                                            htmlType="submit"
                                            className={classNames({
                                                GreenBtn:
                                                    verificationCode &&
                                                    verificationCode.length >=
                                                        6 &&
                                                    buttonStatus,
                                            })}
                                            disabled={
                                                verificationCode &&
                                                verificationCode.length >= 6 &&
                                                buttonStatus
                                                    ? false
                                                    : true
                                            }
                                        >
                                            立即验证
                                        </Button>
                                    </div>
                                </Item>
                            ) : (
                                <Item {...tailFormItemLayout}>
                                    <div className="btn-wrap verificationSubmitBtn">
                                        <Button
                                            // style={{background: '#35c95b', color: '#fff'}}
                                            size="large"
                                            type="primary"
                                            htmlType="submit"
                                            disabled={
                                                verificationCode &&
                                                verificationCode.length >= 6 &&
                                                buttonStatus
                                                    ? false
                                                    : true
                                            }
                                            block
                                        >
                                            立即验证
                                        </Button>
                                    </div>
                                </Item>
                            )}
                            {this.props.otpParam && (
                                <center>
                                    您还有（
                                    <span className="blue">
                                        {this.props.attemptRemaining}
                                    </span>
                                    ）次尝试机会{" "}
                                </center>
                            )}
                        </Form>
                    </Spin>
                </Modal>

                <ExceedVerify /* otp 超過次數彈窗 */
                    exceedVisible={exceedVisible}
                    times={this.props.times}
                    headTitle={
                        this.props.otpParam === "login-otp"
                            ? `超过尝试次数`
                            : this.props.otpParam === "memberProfile-otp"
                            ? `超过尝试次数`
                            : "手机验证"
                    }
                    offset={{ left: "5%" }}
                    onCancel={() => {
                        this.setState({ exceedVisible: false });
                        setTimeout(() => {
                            global.globalExit();
                            Router.push("/cn/");
                        }, 1500);
                    }}
                    otpParam={this.props.otpParam}
                    Description={
                        // this.props.kindOfVerifications === "revalidate" ? (
                        //     <div
                        //         className="otp-cs-tip"
                        //         style={{ textAlign: "center" }}
                        //     >
                        //         请联系
                        //         <span
                        //             className="otp-cs"
                        //             onClick={() => {
                        //                 global.PopUpLiveChat();
                        //                 Pushgtagdata("CS_exceeded_revalidate");
                        //                 global.globalExit();
                        //             }}
                        //         >
                        //             在线客服
                        //         </span>
                        //         以验证并更新密码。
                        //     </div>
                        // ) : this.props.otpParam === "memberProfile-otp" ? (
                        //     <div
                        //         className="otp-cs-tip"
                        //         style={{
                        //             textAlign: "center",
                        //             color: "#000000",
                        //         }}
                        //     >
                        //         您已超过5次尝试，请24小时之后再试。或联系我们的在线客服进行验证。
                        //     </div>
                        // ) : (
                        //     <div className="otp-cs-tip">
                        //         您已超过5次尝试，请24小时之后再试或联系我们的
                        //         <span
                        //             className="otp-cs"
                        //             onClick={() => {
                        //                 global.PopUpLiveChat();
                        //                 Pushgtagdata("CS_exceeded_loginOTP");
                        //             }}
                        //         >
                        //             在线客服
                        //         </span>
                        //         进行验证。
                        //     </div>
                        // )
                        <div className="otp-cs-tip-exceed">
                            请24小时之后再试或联系我们的在线客服进行验证。
                        </div>
                    }
                    btnInfo={this.props.kindOfVerifications}
                />
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        memberInfo: state.userCenter.memberInfo,
    };
}
function mapDispatchToProps(dispatch) {
    return {};
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create({ name: "PhoneVerify" })(PhoneVerify));
